import createReducer from 'packages/core/utils/createReducer'
import initialState from 'app/data/menu'
import { ReducerRecord } from './records'

// export default createReducer(initialState, {})
export default createReducer({ data: ReducerRecord(initialState) }, {})
